import { COLLISION_COLOURS } from '../../../constants/Constants';
import { CollisionCollider } from '../collisions/CollisionCollider';

export class WorldObject extends Phaser.GameObjects.Image {
  constructor(scene, layer, config) {
    super(scene, config.x, config.y, config.sprite.sheet, config.sprite.frame);
    layer.add(this);
    this.type = 'object';
    this.model = config;

    this.setOrigin(0.5, 1);

    if (config.collider) {
      this._bodyCollider = new CollisionCollider(this.scene, {
        x: this.x + config.collider.x - this.width * 0.5,
        y: this.y - this.height + config.collider.y,
        width: config.collider.width,
        height: config.collider.height,
        gameObject: this,
        debugColour: COLLISION_COLOURS.SOLID,
      });
    }
  }

  get bodyCollider() {
    return this._bodyCollider;
  }

  destroy() {
    if (this._bodyCollider) {
      this._bodyCollider.destroy();
      this._bodyCollider = null;
    }
    super.destroy();
  }
}
